import React from 'react';

/**
 * SummaryViewToggle
 *
 * Switches the review modal between the document summary and the extracted
 * data points. Renders nothing when the document has no data points, so
 * documents whose type has no Extract_* prompt look exactly as they did
 * before extraction existed. Pass a distinct idPrefix when more than one
 * toggle is on the page (the radios are grouped by name).
 */
const SummaryViewToggle = ({ value, onChange, hasDataPoints, idPrefix = 'summary-content-view' }) => {
  if (!hasDataPoints) {
    return null;
  }

  const options = [
    { key: 'summary', label: 'Summary', icon: 'bi-file-text' },
    { key: 'data', label: 'Data Points', icon: 'bi-table' },
  ];

  return (
    <div
      className="btn-group btn-group-sm ms-1"
      role="group"
      aria-label="Summary or data points view"
      data-testid="summary-view-toggle"
    >
      {options.map(({ key, label, icon }) => (
        <React.Fragment key={key}>
          <input
            type="radio"
            className="btn-check"
            name={idPrefix}
            id={`${idPrefix}-${key}`}
            autoComplete="off"
            checked={value === key}
            onChange={() => onChange(key)}
          />
          <label className="btn btn-outline-primary" htmlFor={`${idPrefix}-${key}`}>
            <i className={`bi ${icon} me-1`}></i>{label}
          </label>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SummaryViewToggle;
